module.exports = __webpack_public_path__ + "r5-2e345bac.webp";